module.exports = __webpack_public_path__ + "static/img/miniImg4.14c5f200.png";